export default "/images/vendor/flag-icons/flags/4x3/nr.svg?0d87ce78609053fbd9c4f63bef208df9";